module.exports = __webpack_public_path__ + "img/coach-complete.27192fcd.svg";